var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入品牌名称" },
            model: {
              value: _vm.searchData.name,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "name", $$v)
              },
              expression: "searchData.name"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入品牌编码" },
            model: {
              value: _vm.searchData.code,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "code", $$v)
              },
              expression: "searchData.code"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleSearch }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.handleReset }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                prop: column.prop,
                label: column.label,
                formatter: column.formatter
              }
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "340", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "router-link",
                      { attrs: { to: "/static/brand/model/" + scope.row.id } },
                      [
                        _c(
                          "el-button",
                          { attrs: { type: "primary", size: "mini" } },
                          [_vm._v("产品型号")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleDealPrivacy(scope.row)
                          }
                        }
                      },
                      [_vm._v("自定义")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "info", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.checkHistory(scope.row)
                          }
                        }
                      },
                      [_vm._v("历史记录")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showPath,
            center: "",
            title: "获取上传路径",
            width: "400px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showPath = $event
            },
            close: _vm.onPathDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "pathForm",
              attrs: {
                model: _vm.pathForm,
                rules: _vm.pathFormRule,
                "label-position": "left",
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "文件类型", prop: "fileType", required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择文件类型", disabled: "" },
                      model: {
                        value: _vm.pathForm.fileType,
                        callback: function($$v) {
                          _vm.$set(_vm.pathForm, "fileType", $$v)
                        },
                        expression: "pathForm.fileType"
                      }
                    },
                    _vm._l(_vm.fileTypeList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "品牌编码", prop: "brandCode", required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择品牌", disabled: "" },
                      model: {
                        value: _vm.pathForm.brandCode,
                        callback: function($$v) {
                          _vm.$set(_vm.pathForm, "brandCode", $$v)
                        },
                        expression: "pathForm.brandCode"
                      }
                    },
                    _vm._l(_vm.brandList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本号", prop: "version", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "例如：x.x.x", clearable: "" },
                    model: {
                      value: _vm.pathForm.version,
                      callback: function($$v) {
                        _vm.$set(_vm.pathForm, "version", $$v)
                      },
                      expression: "pathForm.version"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "自定义路径", prop: "customDir" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "例如：/dir1/dir2",
                        clearable: "",
                        "default-first-option": "",
                        "allow-create": "",
                        filterable: ""
                      },
                      model: {
                        value: _vm.pathForm.customDir,
                        callback: function($$v) {
                          _vm.$set(_vm.pathForm, "customDir", $$v)
                        },
                        expression: "pathForm.customDir"
                      }
                    },
                    _vm._l(_vm.customDirList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "tips" }, [
                _vm._v(
                  "自定义路径必须以 / 开头，不以 / 结尾，只支持英文、数字、下划线、中划线，支持多层目录"
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "版本说明",
                      type: "textarea",
                      autosize: "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.pathForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.pathForm, "remark", $$v)
                      },
                      expression: "pathForm.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onPathDialogClose } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmitPath }
                    },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFile,
            center: "",
            title: "文件上传",
            width: "400px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showFile = $event
            },
            close: _vm.onFileDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.uploading,
                  expression: "uploading"
                }
              ],
              ref: "uploadForm",
              attrs: {
                model: _vm.uploadForm,
                rules: _vm.uploadFormRule,
                "label-position": "left",
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "文件", prop: "fileType", required: "" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        "http-request": _vm.handleFileUpload,
                        action: "string",
                        "before-upload": _vm.handleBeforeUpload,
                        "on-success": _vm.handleSuccess,
                        "on-error": _vm.handleError,
                        accept: ".zip,.img",
                        "show-file-list": false
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.uploadForm.downloadUrl))])
                ],
                1
              ),
              _vm._v(" "),
              _vm.uploadForm.downloadUrl
                ? _c(
                    "el-form-item",
                    { attrs: { label: "文件路径" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.uploadForm.targetOssPath))
                      ]),
                      _vm._v(" "),
                      _c("el-button", {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:success",
                            value: _vm.handleCopy,
                            expression: "handleCopy",
                            arg: "success"
                          },
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: _vm.uploadForm.targetOssPath,
                            expression: "uploadForm.targetOssPath",
                            arg: "copy"
                          }
                        ],
                        attrs: { type: "text", icon: "el-icon-copy-document" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "tips" }, [
                _vm._v(
                  "只支持.zip文件，对将要上传的文件进行压缩上传。（协议隐私类型的，直接对协议隐私文档进行压缩）"
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onFileDialogClose } }, [
                    _vm._v("关闭")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showRecord,
            center: "",
            title: "历史记录",
            width: "90vw"
          },
          on: {
            "update:visible": function($event) {
              _vm.showRecord = $event
            },
            close: function($event) {
              _vm.showRecord = false
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "filter-container" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "自定义目录",
                    clearable: "",
                    filterable: ""
                  },
                  model: {
                    value: _vm.recordSearchData.customDir,
                    callback: function($$v) {
                      _vm.$set(_vm.recordSearchData, "customDir", $$v)
                    },
                    expression: "recordSearchData.customDir"
                  }
                },
                _vm._l(_vm.customDirList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item, value: item }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleRecordSearch }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "warning", icon: "el-icon-refresh" },
                  on: { click: _vm.handleRecordReset }
                },
                [_vm._v("重置")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.recordData,
                border: "",
                stripe: "",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" }
              }),
              _vm._v(" "),
              _vm._l(_vm.recordColumn, function(column, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    width: column.width,
                    prop: column.prop,
                    label: column.label,
                    formatter: column.formatter
                  }
                })
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100", prop: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(scope.row)
                              }
                            }
                          },
                          [_vm._v("下载文件")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.recordPageData.total > 0,
                    expression: "recordPageData.total > 0"
                  }
                ],
                attrs: {
                  "current-page": _vm.recordPageData.page,
                  "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
                  "page-size": _vm.recordPageData.rows,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.recordPageData.total
                },
                on: {
                  "size-change": _vm.handleRecordSizeChange,
                  "current-change": _vm.handleRecordCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }